export default __webpack_public_path__ + "static/media/cleanup.9422bfc3.jpg";